export default "__VITE_ASSET__3838e719__"